<template>
<div>
 <v-container fluid>
  <div id="printableFormArea" >
  <form @submit.prevent="savecenterdetails">
    <div class="main-section-title mb-4">Pre-school Details</div>
    <div class="section-wrapper">
    <div class="tab-label">
      <span>Basic Information</span>
    </div>
    <v-card class="basic-info-card">
      <v-card-text>
        <v-row>
          <v-col cols="12" md="3">
            <v-autocomplete v-model="preschoolname"
              label="1. Select Preschoolname *"
              placeholder="Select PrechoolName"
              :items="allFranchisees"
              key="id"
              item-value="id"
              item-text="companyName"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field v-model="district"
              label="2. Select District*"
              placeholder="Select District"
              outlined
              dense
              :rules="[v => !!v && v.trim().length > 0]"
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field v-model="block"
              label="3. Select Block *"
              placeholder="Select Block"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field v-model="village"
              label="4. Select village *"
              placeholder="Select village"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field v-model="nearestPrimarySchool"
              label="5. Nearest Primary School *"
              placeholder="Nearest Primary School"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field v-model="cluster"
              label="6. Cluster"
              placeholder="Cluster"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field v-model="preschoolnumber"
              label="7. Pre-School Number (Auto-Generated)"
              placeholder="Preschool Number"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field v-model="address"
              label="8. Address / Landmark"
              placeholder= "Enter Address / Landmark"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-autocomplete v-model="management"
              :items="PreschoolManagement"
              item-text="text"
              item-value="value"
              label="9. Management"
              placeholder="Select Management"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-autocomplete v-model="medium"
              :items="PreschoolMedium" item-text="text"
              item-value="value"
              label="10. Medium"
              placeholder= "Select Medium"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-autocomplete v-model="category"
              :items="PreschoolCategory" item-text="text"
              item-value="value"
              label="11. Category"
              placeholder= "Select Category"
              outlined
              dense
            />
            </v-col>
            <v-col cols="12" md="3">
            <v-text-field v-model="preschoolEmail"
              label="12. Pre-School Email"
              placeholder= "Enter Pre-School Email"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field v-model="preschoolContactNo"
              label="13. Pre-School Contact No."
              placeholder= "Enter Pre-School Contact No."
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-autocomplete v-model="preschoolacademicYear"
              :items="PreschoolAcademicYear"
              item-text="text"
              item-value="value"
              label="14. Academic Year from which school has started functioning"
              placeholder= "Select Academic Year"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field v-model="preschoolwebsite"
              label="15. Pre-School Website(If exists)"
              placeholder= "Preschool Website"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-autocomplete v-model="lowestClass"
              :items="PreschoolLowestclass"
              item-text="text"
              item-value="value"
              label="16. Lowest Class *"
              placeholder= "Select Lowest Class"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-autocomplete v-model="highestClass"
              :items="Preschoolhighestclass"
              item-text="text"
              item-value="value"
              label="17. Highest Class *"
              placeholder= "Select Highest Class"
              outlined
              dense
            />
          </v-col>
        </v-row>
        </v-card-text>
        </v-card>
    </div>
    <v-dialog v-model="popup" max-width="400">
  <v-card>
    <v-card-title class="headline">{{ popupMsg }}</v-card-title>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" text @click="popup = false">
        OK
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
    <div class="section-wrapper">
    <div class="tab-label">
      <span>Management Details</span>
    </div>
    <v-card class="basic-info-card">
      <v-card-text>
        <v-row>
          <v-col cols="12" md="3">
            <v-text-field v-model="managementreptname"
              label="1. Management Representative Name"
              placeholder="Enter Name"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field v-model="managementreptemail"
              label="2. Management Representative Email"
              placeholder="Enter Email"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field v-model="managementreptmobile"
              label="3. Management Representative Mobile"
              placeholder="Enter Mobile No."
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-autocomplete v-model="managementreptdesignation"
              :items="ManagementDesignation"
              item-text="text"
              item-value="value"
              label="4. Management Representative Designation"
              placeholder="Select Designation"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field v-model="schoolregistrationnumber"
              label="5. School Registration Number (If Any)"
              placeholder="Enter Registration Number"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field v-model="principalname"
              label="6. Principal/Head Master/In-charge Name *"
              placeholder= "Enter Name"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field v-model="principalemail"
              label="7.  Principal/Head Master/In-charge Email"
              placeholder= "Enter Email"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field v-model="principalmobile"
              label="8. Principal/Head Master/In-charge Mobile*"
              placeholder= "Enter Mobile"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-autocomplete v-model="principalhighqualification"
              :items="PrinciplehighQualification"
              item-text="text"
              item-value="value"
              label="9. Principal/Head Master/In-charge Highest Qualification"
              placeholder= "Select Qualification"
              outlined
              dense
            />
            </v-col>
            <v-col cols="12" md="3">
            <v-autocomplete v-model="principalprofqualification"
              :items="PrincipleprofQualification"
              item-text="text"
              item-value="value"
              label="10. Principal/Head Master/In-charge Professional Qualification"
              placeholder= "Enter Qualification"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" md="3">
          <v-file-input
            v-model="principalCertificate"
            accept=".pdf"
            label="11. Principal/Head Master/In-charge Educational & Professional Certificate"
            placeholder="Choose file"
            outlined
            dense
            @change="onFileChange($event, 'principal')"
            :rules="[fileRules]"
          />
          <small class="red--text">Note: Select a PDF file smaller than 1 MB</small>
        </v-col>
        </v-row>
        </v-card-text>
        </v-card>
    </div>
    <div class="section-wrapper">
    <div class="tab-label">
      <span>Student and Classroom Details</span>
    </div>
    <v-card class="basic-info-card">
      <v-card-text>
        <v-row>
          <v-col
            v-for="classObj in classesToShow"
            :key="classObj.value"
            cols="12"
            md="4"
          >
            <v-card class="student-class-card" flat>
              <v-card-title class="justify-center font-weight-bold">
                {{ classObj.text }}
              </v-card-title>
              <v-card-text>
                <v-text-field
                  v-model="classDetails[classObj.value].boys"
                  label="Total No. of Boys:"
                  outlined
                  dense
                  type="number"
                />
                <v-text-field
                  v-model="classDetails[classObj.value].girls"
                  label="Total No. of Girls:"
                  outlined
                  dense
                  type="number"
                />
                <v-text-field
                  :value="Number(classDetails[classObj.value].boys || 0) + Number(classDetails[classObj.value].girls || 0)"
                  label="Total:"
                  outlined
                  dense
                  readonly
                />
                <v-text-field
                  v-model="classDetails[classObj.value].classrooms"
                  label="Total Classrooms:"
                  outlined
                  dense
                  type="number"
                />
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        </v-card-text>
        </v-card>
    </div>
    <div class="section-wrapper">
    <div class="tab-label">
      <span>Infrastructure Details</span>
    </div>
    <v-card class="basic-info-card">
      <v-card-text>
        <v-row>
           <!-- 1. Building -->
            <v-col cols="12" md="3">
              <span class="font-weight-bold">1. Building</span>
              <v-radio-group v-model="infra.buildingType" row>
                <v-radio label="Owned" value="owned" />
                <v-radio label="Leased" value="leased" />
              </v-radio-group>
              <span>Building Completion Certificate</span>
              <v-file-input
                v-model="infra.buildingCert"
                accept=".pdf"
                dense
                outlined
                hide-details
                :rules="[fileRules]"
                @change="onFileChange($event, 'building')"
              />
              <small class="red--text">Note: Select a PDF file with a size less than 1 MB</small>
            </v-col>
            <!-- 2. Is Health Hygiene maintained? -->
            <v-col cols="12" md="2">
              <span class="font-weight-bold">2. Is Health Hygiene maintained?</span>
              <v-radio-group v-model="infra.healthHygiene" row>
                <v-radio label="Yes" value="yes" />
                <v-radio label="No" value="no" />
              </v-radio-group>
            </v-col>
            <!-- 3. Is Sanitation maintained? -->
            <v-col cols="12" md="2">
              <span class="font-weight-bold">3. Is Sanitation maintained?</span>
              <v-radio-group v-model="infra.sanitation" row>
                <v-radio label="Yes" value="yes" />
                <v-radio label="No" value="no" />
              </v-radio-group>
            </v-col>
            <!-- 4. Is Cleanliness maintained? -->
            <v-col cols="12" md="3">
              <span class="font-weight-bold">4. Is Cleanliness maintained?</span>
              <v-radio-group v-model="infra.cleanliness" row>
                <v-radio label="Yes" value="yes" />
                <v-radio label="No" value="no" />
              </v-radio-group>

              <template v-if="infra.cleanliness !== 'no'">
                <span>Cleanliness Maintenance Certificate</span>
                <v-file-input
                  v-model="infra.cleanlinessCert"
                  accept=".pdf"
                  dense
                  outlined
                  hide-details
                  :rules="[fileRules]"
                  @change="onFileChange($event, 'cleanliness')"
                />
                <small class="red--text">Note: Select a PDF file with a size less than 1 MB</small>
              </template>
            </v-col>
            <!-- 5. Facility -->
            <v-col cols="12" md="2">
              <span class="font-weight-bold">5. Facility</span>
              <v-checkbox v-model="infra.facility" label="Playground" value="playground" hide-details />
              <v-checkbox v-model="infra.facility" label="Water Tank" value="water_tank" hide-details />
              <v-checkbox v-model="infra.facility" label="Occupational Safety" value="occupational_safety" hide-details />
              <v-checkbox v-model="infra.facility" label="CCTV" value="cctv" hide-details />
            </v-col>
          </v-row>
          <v-row>
            <!-- 6. Total Number of Washrooms -->
            <v-col cols="12" md="2">
              <span class="font-weight-bold">6. Total Number of Washrooms</span>
              <v-text-field
                v-model="infra.washrooms"
                type="number"
                min="0"
                dense
                outlined
              />
            </v-col>
            <!-- 7. Area of Pre-School (Sq ft) -->
            <v-col cols="12" md="3">
              <span class="font-weight-bold">7. Area of Pre-School (Sq ft)</span>
              <v-text-field
                v-model="infra.area"
                placeholder="Enter area..."
                dense
                outlined
              />
            </v-col>
            <!-- 8. Water Storage Capacity (Liters) -->
            <v-col cols="12" md="3">
              <span class="font-weight-bold">8. Water Storage Capacity (Liters)</span>
              <v-text-field
                v-model="infra.waterStorage"
                placeholder="Enter capacity..."
                dense
                outlined
              />
            </v-col>
           <!-- 9. Are attendants available in the pre-school? -->
          <v-col cols="12" md="6">
            <span class="font-weight-bold">9. Are attendants available in the pre-school?</span>
            <v-radio-group v-model="infra.attendants" row>
              <v-radio label="Yes" value="yes" />
              <v-radio label="No" value="no" />
            </v-radio-group>

            <!-- Show only if 'Yes' selected -->
            <template v-if="infra.attendants === 'yes'">
              <v-row>
                <v-col cols="12" sm="4" class="d-flex align-center">
                  <span class="mr-2">Male :</span>
                  <v-text-field
                    v-model.number="infra.attendantMale"
                    type="number"
                    min="0"
                    dense
                    outlined
                    class="mt-0"
                    hide-details
                  />
                </v-col>
                <v-col cols="12" sm="4" class="d-flex align-center">
                  <span class="mr-2">Female :</span>
                  <v-text-field
                    v-model.number="infra.attendantFemale"
                    type="number"
                    min="0"
                    dense
                    outlined
                    class="mt-0"
                    hide-details
                  />
                </v-col>
                <v-col cols="12" sm="4" class="d-flex align-center">
                  <span class="mr-2">Total :</span>
                  <v-text-field
                    :value="infra.attendantMale + infra.attendantFemale"
                    readonly
                    dense
                    outlined
                    class="mt-0"
                    hide-details
                  />
                </v-col>
              </v-row>
            </template>
          </v-col>
            <!-- 10. Children With Special Needs -->
              <v-col cols="12" md="2">
                <span class="font-weight-bold">10. Children With Special Needs</span>
                <v-radio-group v-model="infra.specialNeeds" row>
                  <v-radio label="Yes" value="yes" />
                  <v-radio label="No" value="no" />
                </v-radio-group>
              </v-col>
              <!-- Show this block only if 'Yes' is selected -->
            <template v-if="infra.specialNeeds === 'yes'">
              <v-col
                v-for="classObj in classesToShow"
                :key="classObj.value"
                cols="12"
                md="3"
              >
                <span class="font-weight-bold">
                  {{ classObj.text }}:
                </span>
                <v-text-field
                  v-model.number="specialNeedsInput[classObj.value].boys"
                  label="Boys"
                  dense
                  outlined
                  type="number"
                  class="mt-1"
                />
                <v-text-field
                  v-model.number="specialNeedsInput[classObj.value].girls"
                  label="Girls"
                  dense
                  outlined
                  type="number"
                  class="mt-1"
                />
                <v-text-field
                  :value="Number(specialNeedsInput[classObj.value].boys || 0) + Number(specialNeedsInput[classObj.value].girls || 0)"
                  label="Total"
                  dense
                  outlined
                  readonly
                  class="mt-1"
                />
              </v-col>
            </template>
          </v-row>
        </v-card-text>
        </v-card>
    </div>
    <v-dialog v-model="popup" max-width="400">
  <v-card>
    <v-card-title class="headline">{{ popupMsg }}</v-card-title>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" text @click="popup = false">
        OK
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
<div class="section-wrapper">
  <div class="tab-label">
    <span>Staff Details</span>
  </div>

  <v-card class="staff-info-card">
    <v-card-text>
      <div v-for="(staff, index) in staffList" :key="index">
        <v-row>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="staff.name"
              label="Name *"
              placeholder="Enter Name"
              outlined
              dense
            />
          </v-col>

          <v-col cols="12" md="3">
            <v-autocomplete
              v-model="staff.type"
              :items="['Teaching', 'Non-Teaching', 'Other']"
              label="Teaching Type *"
              placeholder="Select Teaching Type"
              outlined
              dense
            />
          </v-col>

          <v-col cols="12" md="3">
            <v-autocomplete
              v-model="staff.highestEdu"
              :items="['SSC', 'HSC', 'Graduate', 'Post Graduate','Other']"
              label="Highest Educational Qualification *"
              placeholder="Select Qualification"
              outlined
              dense
            />
          </v-col>

          <v-col cols="12" md="3">
            <v-autocomplete
              v-model="staff.profQualification"
              :items="['ECCE Certified', 'SCERT Certified', 'D.Ed', 'B.Ed', 'Other']"
              label="Professional Qualification *"
              placeholder="Select Qualification"
              outlined
              dense
            />
          </v-col>

          <v-col cols="12" md="3">
            <v-menu
              v-model="dobMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="staff.dob"
                  label="Date of Birth *"
                  readonly
                  outlined
                  dense
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="staff.dob"
                @input="dobMenu = false"
                :max="maxDate"
                color="primary"
                no-title
                scrollable
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" md="3">
            <v-menu
              v-model="dojMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="staff.doj"
                  label="Date of Joining *"
                  readonly
                  outlined
                  dense
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="staff.doj"
                @input="dojMenu = false"
                :max="maxDate"
                color="primary"
                no-title
                scrollable
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" md="3">
            <v-autocomplete
              v-model="staff.gender"
              :items="['Male', 'Female', 'Transgender']"
              label="Gender *"
              placeholder="Select Gender"
              outlined
              dense
            />
          </v-col>

          <v-col cols="12" md="3">
            <label class="mb-2 font-weight-medium">Professional Qualification Certifications *</label>
            <v-checkbox
              v-for="cert in ['ECCE', 'SCERT', 'Other']"
              :key="cert"
              v-model="staff.certifications"
              :label="cert"
              :value="cert"
              dense
              hide-details
            />
          </v-col>

          <v-col cols="12" md="1">
            <label class="mb-2 font-weight-medium">Add Staff</label>
            <v-btn
              small icon color="primary"
              @click="addStaff"
              v-if="index === staffList.length - 1"
              class="mt-6"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
            <v-btn
              small icon color="red"
              @click="removeStaff(index)"
              v-if="staffList.length > 1"
              class="mt-6"
            >
              <v-icon>mdi-minus</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <v-divider class="my-4" v-if="index < staffList.length - 1" />
      </div>
    </v-card-text>
  </v-card>
</div>
 <v-btn color="success" elevation="1" type="submit">
    <v-icon left>mdi-text-box-check-outline </v-icon>
    Save
  </v-btn>
</form>
    </div>
  </v-container>
  <div v-show="printMode" id="printableSummary">
      <h2 class="main-section-title mb-4">Pre-school Details</h2>
      <!-- Basic Information -->
      <div class="section-wrapper">
      <div class="tab-label"><span>Basic Information</span></div>
      <div class="form-grid">
        <div class="form-row">
          <div class="form-field">
            <div class="form-label">1. Pre-School Name *</div>
            <div class="form-box">{{ preschoolnameText }}</div>
          </div>
          <div class="form-field">
            <div class="form-label">2. Select District *</div>
            <div class="form-box">{{ district }}</div>
          </div>
          <div class="form-field">
            <div class="form-label">3. Select Block *</div>
            <div class="form-box">{{ block }}</div>
          </div>
          <div class="form-field">
            <div class="form-label">4. Select Village *</div>
            <div class="form-box">{{ village }}</div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-field">
            <div class="form-label">5. Nearest Primary School *</div>
            <div class="form-box">{{ nearestPrimarySchool }}</div>
          </div>
          <div class="form-field">
            <div class="form-label">6. Cluster</div>
            <div class="form-box">{{ cluster }}</div>
          </div>
          <div class="form-field">
            <div class="form-label">7. Pre-School Number</div>
            <div class="form-box">{{ preschoolnumber }}</div>
          </div>
          <div class="form-field">
            <div class="form-label">8. Address / Landmark</div>
            <div class="form-box">{{ address }}</div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-field">
            <div class="form-label">9. Management</div>
            <div class="form-box">{{ management }}</div>
          </div>
          <div class="form-field">
            <div class="form-label">10. Medium</div>
            <div class="form-box">{{ medium }}</div>
          </div>
          <div class="form-field">
            <div class="form-label">11. Category</div>
            <div class="form-box">{{ category }}</div>
          </div>
          <div class="form-field">
            <div class="form-label">12. Pre-School Email</div>
            <div class="form-box">{{ preschoolEmail }}</div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-field">
            <div class="form-label">13. Pre-School Contact No.</div>
            <div class="form-box">{{ preschoolContactNo }}</div>
          </div>
          <div class="form-field">
            <div class="form-label">14. Academic Year Started</div>
            <div class="form-box">{{ preschoolacademicYear }}</div>
          </div>
          <div class="form-field">
            <div class="form-label">15. Pre-School Website</div>
            <div class="form-box">{{ preschoolwebsite }}</div>
          </div>
          <div class="form-field">
            <div class="form-label">16. Lowest Class</div>
            <div class="form-box">{{ lowestClass }}</div>
          </div>
          <div class="form-field" cols="10" md="3">
            <div class="form-label">17. Highest Class</div>
            <div class="form-box">{{ highestClass }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- Management Details -->
    <div class="section-wrapper">
      <div class="tab-label"><span>Management Details</span></div>
      <div class="form-grid">
        <div class="form-row">
          <div class="form-field">
            <div class="form-label">1. Management Representative Name</div>
            <div class="form-box">{{ managementreptname }}</div>
          </div>
          <div class="form-field">
            <div class="form-label">2. Management Representative Email</div>
            <div class="form-box">{{ managementreptemail }}</div>
          </div>
          <div class="form-field">
            <div class="form-label">3. Management Representative Mobile</div>
            <div class="form-box">{{ managementreptmobile }}</div>
          </div>
          <div class="form-field">
            <div class="form-label">4. Management Representative Designation</div>
            <div class="form-box">{{ managementreptdesignation }}</div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-field">
            <div class="form-label">5. School Registration Number</div>
            <div class="form-box">{{ schoolregistrationnumber }}</div>
          </div>
          <div class="form-field">
            <div class="form-label">6. Principal Name</div>
            <div class="form-box">{{ principalname }}</div>
          </div>
          <div class="form-field">
            <div class="form-label">7. Principal Email</div>
            <div class="form-box">{{ principalemail }}</div>
          </div>
          <div class="form-field">
            <div class="form-label">8. Principal Mobile</div>
            <div class="form-box">{{ principalmobile }}</div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-field">
            <div class="form-label">9. Principal Highest Qualification</div>
            <div class="form-box">{{ principalhighqualification }}</div>
          </div>
          <div class="form-field">
            <div class="form-label">10. Principal Professional Qualification</div>
            <div class="form-box">{{ principalprofqualification }}</div>
          </div>
          <div class="form-field">
            <div class="form-label">11. Principal Certificate</div>
            <div class="form-box">{{ principalCertificate ? 'Uploaded' : 'Not Uploaded' }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- Student and Classroom Details -->
    <div class="section-wrapper">
      <div class="tab-label"><span>Student and Classroom Details</span></div>
      <div class="form-grid">
        <div class="form-row" v-for="classObj in allClasses" :key="classObj.value">
          <div class="form-field">
            <div class="form-label">{{ classObj.text }} - Total No. of Boys</div>
            <div class="form-box">{{ classDetails[classObj.value].boys }}</div>
          </div>
          <div class="form-field">
            <div class="form-label">{{ classObj.text }} - Total No. of Girls</div>
            <div class="form-box">{{ classDetails[classObj.value].girls }}</div>
          </div>
          <div class="form-field">
            <div class="form-label">{{ classObj.text }} - Total</div>
            <div class="form-box">{{ Number(classDetails[classObj.value].boys || 0) + Number(classDetails[classObj.value].girls || 0) }}</div>
          </div>
          <div class="form-field">
            <div class="form-label">{{ classObj.text }} - Total Classrooms</div>
            <div class="form-box">{{ classDetails[classObj.value].classrooms }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- Infrastructure Details -->
    <div class="section-wrapper">
      <div class="tab-label"><span>Infrastructure Details</span></div>
      <div class="form-grid">
        <div class="form-row">
          <div class="form-field">
            <div class="form-label">1. Building</div>
            <div class="form-box">
              <span class="radio">{{ infra.buildingType === 'owned' ? '●' : '○' }} Owned</span>
              <span class="radio">{{ infra.buildingType === 'leased' ? '●' : '○' }} Leased</span>
            </div>
          </div>
          <div class="form-field">
            <div class="form-label">Building Completion Certificate</div>
            <div class="form-box">{{ infra.buildingCert ? 'Uploaded' : 'Not Uploaded' }}</div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-field">
            <div class="form-label">2. Health Hygiene Maintained</div>
            <div class="form-box">
              <span class="radio">{{ infra.healthHygiene === 'yes' ? '●' : '○' }} Yes</span>
              <span class="radio">{{ infra.healthHygiene === 'no' ? '●' : '○' }} No</span>
            </div>
          </div>
          <div class="form-field">
            <div class="form-label">3. Sanitation Maintained</div>
            <div class="form-box">
              <span class="radio">{{ infra.sanitation === 'yes' ? '●' : '○' }} Yes</span>
              <span class="radio">{{ infra.sanitation === 'no' ? '●' : '○' }} No</span>
            </div>
          </div>
          <div class="form-field">
            <div class="form-label">4. Cleanliness Maintained</div>
            <div class="form-box">
              <span class="radio">{{ infra.cleanliness === 'yes' ? '●' : '○' }} Yes</span>
              <span class="radio">{{ infra.cleanliness === 'no' ? '●' : '○' }} No</span>
            </div>
          </div>
          <div class="form-field" v-if="infra.cleanliness !== 'no'">
            <div class="form-label">Cleanliness Maintenance Certificate</div>
            <div class="form-box">{{ infra.cleanlinessCert ? 'Uploaded' : 'Not Uploaded' }}</div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-field">
            <div class="form-label">5. Facility</div>
            <div class="form-box">{{ Array.isArray(infra.facility) ? infra.facility.join(', ') : infra.facility }}</div>
          </div>
          <div class="form-field">
            <div class="form-label">6. Total Washrooms</div>
            <div class="form-box">{{ infra.washrooms }}</div>
          </div>
          <div class="form-field">
            <div class="form-label">7. Area of Pre-School (Sq ft)</div>
            <div class="form-box">{{ infra.area }}</div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-field">
            <div class="form-label">8. Water Storage Capacity (Liters)</div>
            <div class="form-box">{{ infra.waterStorage }}</div>
          </div>
          <div class="form-field">
            <div class="form-label">9. Are attendants available?</div>
            <div class="form-box">
              <span class="radio">{{ infra.attendants === 'yes' ? '●' : '○' }} Yes</span>
              <span class="radio">{{ infra.attendants === 'no' ? '●' : '○' }} No</span>
            </div>
          </div>
          <div class="form-field" v-if="infra.attendants === 'yes'">
            <div class="form-label">Male</div>
            <div class="form-box">{{ infra.attendantMale }}</div>
          </div>
          <div class="form-field" v-if="infra.attendants === 'yes'">
            <div class="form-label">Female</div>
            <div class="form-box">{{ infra.attendantFemale }}</div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-field">
            <div class="form-label">10. Children With Special Needs</div>
            <div class="form-box">
              <span class="radio">{{ infra.specialNeeds === 'yes' ? '●' : '○' }} Yes</span>
              <span class="radio">{{ infra.specialNeeds === 'no' ? '●' : '○' }} No</span>
            </div>
          </div>
          <div class="form-field" v-if="infra.specialNeeds === 'yes'">
            <div v-for="classObj in allClasses" :key="'cwsn-' + classObj.value">
              <div class="form-label">{{ classObj.text }} - Boys</div>
              <div class="form-box">{{ specialNeedsInput[classObj.value].boys }}</div>
              <div class="form-label">{{ classObj.text }} - Girls</div>
              <div class="form-box">{{ specialNeedsInput[classObj.value].girls }}</div>
              <div class="form-label">{{ classObj.text }} - Total</div>
              <div class="form-box">{{ Number(specialNeedsInput[classObj.value].boys || 0) + Number(specialNeedsInput[classObj.value].girls || 0) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Staff Details -->
    <div class="section-wrapper">
      <div class="tab-label"><span>Staff Details</span></div>
      <table class="staff-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Teaching Type</th>
            <th>Highest Education</th>
            <th>Professional Qualification</th>
            <th>Date of Birth</th>
            <th>Date of Joining</th>
            <th>Gender</th>
            <th>Certifications</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(staff, idx) in staffList" :key="idx">
            <td class="form-box">{{ staff.name }}</td>
            <td class="form-box">{{ staff.type }}</td>
            <td class="form-box">{{ staff.highestEdu }}</td>
            <td class="form-box">{{ staff.profQualification }}</td>
            <td class="form-box">{{ staff.dob }}</td>
            <td class="form-box">{{ staff.doj }}</td>
            <td class="form-box">{{ staff.gender }}</td>
            <td class="form-box">{{ Array.isArray(staff.certifications) ? staff.certifications.join(', ') : staff.certifications }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    </div>
 <v-container fluid>
    <material-card
        icon="mdi-clipboard-text"
        inline
        title="Pre-school Details">
          <v-card-actions>
          </v-card-actions>
          <v-card class="px-2" flat>
            <form @submit.prevent="applyFilter">
              <v-row>
                <v-col cols="6" md="3">
                  <label class="body-2 font-weight-medium">
                    Select Zone <span class="error--text">*</span></label
                  >
                  <v-autocomplete
                    class="my-0 py-1"
                    placeholder="--Select--"
                    v-model="selectzone"
                    item-value="name"
                    :items="zones"
                    key="id"
                    item-text="name"
                    @change="getZoneList()"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="6" md="3" v-if="!isFranchiseeUser">
                  <label class="body-2 font-weight-medium">
                    Select Franchisee <span class="error--text">*</span></label
                  >
                  <v-autocomplete
                    class="my-0 py-1"
                    placeholder="--Select--"
                    v-model="selectfranchisee"
                    item-value="id"
                    :items="franchiseeArr"
                    key="id"
                    item-text="companyName"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="inside">
                    <v-btn color="success" elevation="1" type="submit">
                      <v-icon left>mdi-text-box-check-outline </v-icon>
                      Apply
                    </v-btn>
                    <v-btn
                      class="ml-4"
                      height="35"
                      small
                      elevation="1"
                      type="reset"
                      @click="resetAll()"
                    >
                      <v-icon left size="18"> mdi-restart</v-icon>
                      Reset
                    </v-btn>
                    <v-btn class="ml-2" color="primary" elevation="1" @click="downloadCSV()">
                    <v-icon left size="18">mdi-download</v-icon>
                      Download CSV
                    </v-btn>
                    <v-btn class="ml-2" color="primary" elevation="1"
                      v-if="hasSearched && preschoollist.length" @click="downloadFormPDF()">
                      <v-icon left size="18">mdi-download</v-icon>
                      Download PDF
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </form>
          </v-card>
          <v-card-component >
        <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
          <v-card-title>
            Logs : {{ total }}
            <v-spacer></v-spacer>
          </v-card-title>
        </v-card-text>

        <v-divider class=" my-0 " />
        <v-data-table
          :footer-props="{
            'items-per-page-options': [5, 10, 20, 40]
          }"
          :items-per-page="10"
          :headers="headers"
          :items="preschoollist"
          :search="search"
        >
        <template v-slot:item.createdAt="{ item }">
          {{ new Date(item.createdAt).toLocaleDateString() }}
        </template>
          <template v-slot:item.preSchoolName="{ item }">
            {{ item.preSchoolName || '-' }}
          </template>
          <template v-slot:item.district="{ item }">
            {{ item.district || '-' }}
          </template>
          <template v-slot:item.village="{ item }">
            {{ item.village || '-' }}
          </template>
          <template v-slot:item.lowestClass="{ item }">
            {{ item.lowestClass || '-' }}
          </template>
          <template v-slot:item.updatedBy="{ item }">
            {{ item.updatedBy || '-' }}
          </template>
          <template v-slot:item.actions="{ item }">
            <span >
              <!-- Replace below with your edit/view logic -->
              <v-btn class="px-2 ml-1 ma-1" color="success" min-width="0" small
               :to="{ name: 'editpreschooldetails', params: { id: item.id } }">
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
              <v-btn class="px-2 ml-1 ma-1" min-width="0" small
               :to="{ name: 'viewpreschooldetails', params: { id: item.id } }">
                <v-icon small>mdi-eye</v-icon>
              </v-btn>
            </span>
          </template>
          <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
          </template>
        </v-data-table>
        </v-card-component>
      </material-card>
    <loading-icon :value="isLoading" />
   </v-container>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import Utils from '@/utils'
import moment from 'moment'
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
import stores from '@/stores'
import _ from 'lodash'
export default {
  name: 'preschooldetails',
  components: { MaterialCard, VCardComponent },
  data () {
    return {
      id: this.$route.params.id || '',
      total: 0,
      date: moment().format('YYYY-MM-DD'),
      franchiseeID: '',
      search: '',
      franchiseeArr: [],
      academicYearID: '',
      preschoollist: [],
      inProgress: false,
      temp: '',
      isLoading: false,
      type: '',
      academicYears: [],
      selectedClassID: '',
      selectzone: '',
      selectfranchisee: '',
      title: '',
      zones: [],
      hasClicked: false,
      loader: true,
      isWrite: false,
      isFranchiseeUser: false,
      allFranchisees: [],
      headers: [
        { text: 'Date', value: 'createdAt', sortable: true },
        { text: 'Franchisee/Center', value: 'franchisee.companyName', sortable: true },
        { text: 'District', value: 'district', sortable: true },
        { text: 'village', value: 'village', sortable: true },
        { text: 'Lowest Class', value: 'lowestClass', sortable: true },
        { text: 'Edited By', value: 'updatedBy', sortable: true },
        { text: 'Actions', value: 'actions', sortable: true, align: 'center' }
      ],
      preschoolname: '',
      district: '',
      block: '',
      village: '',
      nearestPrimarySchool: '',
      cluster: '',
      preschoolnumber: '',
      address: '',
      management: '',
      medium: '',
      category: '',
      preschoolEmail: '',
      preschoolContactNo: '',
      preschoolacademicYear: '',
      preschoolwebsite: '',
      lowestClass: '',
      highestClass: '',
      managementreptname: '',
      managementreptemail: '',
      managementreptmobile: '',
      managementreptdesignation: '',
      schoolregistrationnumber: '',
      principalname: '',
      principalemail: '',
      principalmobile: '',
      principalhighqualification: '',
      principalprofqualification: '',
      principalcertificate: '',
      PreschoolManagement: constants.PreschoolManagement,
      PreschoolMedium: constants.PreschoolMedium,
      PreschoolCategory: constants.PreschoolCategory,
      nurseryBoys: '',
      nurseryGirls: '',
      nurseryClassrooms: '',
      pp1Boys: '',
      pp1Girls: '',
      pp1Classrooms: '',
      pp2Boys: '',
      pp2Girls: '',
      pp2Classrooms: '',
      PreschoolAcademicYear: Array.from({ length: 2025 - 1970 + 1 }, (_, i) => {
        let year = (1970 + i).toString()
        return { text: year, value: year }
      }),
      PreschoolLowestclass: [
        { text: 'Nursery', value: 'nursery' }
      ],
      Preschoolhighestclass: [
        { text: 'PP II', value: 'pp II' }
      ],
      ManagementDesignation: [
        { text: 'Chairman', value: 'chairman' },
        { text: 'Director', value: 'director' },
        { text: 'Secretary', value: 'secretary' },
        { text: 'Other', value: 'other' }
      ],
      PrinciplehighQualification: [
        { text: 'SSC', value: 'ssc' },
        { text: 'HSC', value: 'hsc' },
        { text: 'Graduate', value: 'graduate' },
        { text: 'Post Graduate', value: 'post graduate' },
        { text: 'Other', value: 'other' }
      ],
      PrincipleprofQualification: [
        { text: 'ECCE Certified', value: 'ecce certified' },
        { text: 'SCERT Certified', value: 'scert certified' },
        { text: 'D.Ed', value: 'd.ed' },
        { text: 'B.Ed', value: 'b.ed' },
        { text: 'Other', value: 'other' }
      ],
      allClasses: [
        { text: 'Nursery', value: 'nursery' },
        { text: 'PP II', value: 'pp II' }
      ],
      classDetails: {
        nursery: { boys: '', girls: '', classrooms: '' },
        'pp II': { boys: '', girls: '', classrooms: '' }
      },
      specialNeeds: {
        nursery: { boys: '', girls: '' },
        'pp II': { boys: '', girls: '' }
      },
      specialNeedsInput: {
        nursery: { boys: '', girls: '' },
        'pp II': { boys: '', girls: '' }
      },
      popup: false,
      popupMsg: '',
      infra: {
        buildingType: '',
        buildingCert: null,
        healthHygiene: '',
        sanitation: '',
        cleanliness: '',
        cleanlinessCert: null,
        facility: [],
        washrooms: '',
        area: '',
        waterStorage: '',
        attendants: '',
        specialNeeds: '',
        attendantMale: 0,
        attendantFemale: 0
      },
      previousCWSNBoys: {},
      previousCWSNGirls: {},
      staffList: [
        {
          name: '',
          type: '',
          highestEdu: '',
          profQualification: '',
          dob: '',
          doj: '',
          gender: '',
          certifications: []
        }
      ],
      printMode: false,
      hasSearched: false,
      isZonalManager: false,
      isSuperAdmin: false,
      isCH_LEVEL1: false,
      isAcademicManager: false,
      principalCertificate: '',
      dobMenu: false,
      dojMenu: false,
      maxDate: new Date().toISOString().substr(0, 10)
    }
  },
  async created () {
    this.isFranchiseeUser = stores.user.me.isFranchiseeUser
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    if (this.academicYearID) {
      await this.getClassList()
    }
    await this.getZoneDetails()
    await this.getCenterLogDetails()
    this.getUserRolesFromIndexDB()
    this.getAllFranchisee()
    this.isSuperAdmin = Utils.helper.isSuperAdmin()
    this.selectfranchisee = this.franchiseeID || ''
    if (this.isFranchiseeUser && this.zones.length > 0) {
      this.selectzone = this.zones[0].name
      await this.getZoneList()
      if (this.franchiseeArr.length > 0) {
        this.selectfranchisee = this.franchiseeArr[0].id
      }
    }
  },
  watch: {
    selectedClassID () {
      this.selectedSectionID = ''
    },
    lowestClass (newVal) {
      if (newVal && !this.highestClass) {
        this.popupMsg = 'Please select the Highest Class before proceeding.'
        this.popup = true
      }
    }
  },
  computed: {
    nurseryTotal () {
      return (parseInt(this.nurseryBoys) || 0) + (parseInt(this.nurseryGirls) || 0)
    },
    pp1Total () {
      return (parseInt(this.pp1Boys) || 0) + (parseInt(this.pp1Girls) || 0)
    },
    pp2Total () {
      return (parseInt(this.pp2Boys) || 0) + (parseInt(this.pp2Girls) || 0)
    },
    classesToShow () {
      if (!this.lowestClass && !this.highestClass) return this.allClasses
      if (this.lowestClass && !this.highestClass) return []
      if (!this.lowestClass && this.highestClass) return this.allClasses.filter(c => c.value === this.highestClass)
      if (this.lowestClass && this.highestClass) {
        return this.allClasses.filter(
          c => c.value === this.lowestClass || c.value === this.highestClass
        )
      }
      return []
    },
    preschoolnameText () {
    // Find the franchisee object by its id
      const match = this.allFranchisees.find(f => String(f.id) === String(this.preschoolname))
      return match ? match.companyName : this.preschoolname
    }
  },
  methods: {
    addStaff () {
      this.staffList.push({
        name: '',
        type: '',
        highestEdu: '',
        profQualification: '',
        dob: '',
        doj: '',
        gender: '',
        certifications: []
      })
    },
    removeStaff (i) {
      this.staffList.splice(i, 1)
    },
    getZoneList: async function () {
      try {
        this.isLoading = true
        let zone = []
        if (this.selectzone) {
          zone = [this.selectzone]
        }
        if (zone.length > 0) {
          const response = await http.post(
            `${constants.API_URL}/api/franchisee/get/zone-wise-franchisee`,
            {
              zone: zone
            }
          )
          let data = response.data
          this.franchiseeArr = _.map(data, (e) => {
            if (e.id) {
              if (e.id.toString().length === 1) {
                e.companyName = `${'(00' + e.id + ')'} ` + e.companyName
              } else if (e.id.toString().length === 2) {
                e.companyName = `${'(0' + e.id + ')'} ` + e.companyName
              } else {
                e.companyName = `${'(' + e.id + ')'} ` + e.companyName
              }
              e.companyName = e.region
                ? e.companyName + `${' (' + e.region + ')'}`
                : e.companyName
            }
            return e
          })
        } else {
          this.franchiseeArr = []
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getZoneDetails: async function () {
      try {
        this.isLoading = true
        let result = await http.get(
          `${constants.API_URL}/api/curriculum_cms/get-zones`
        )
        this.zones = result.data
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getAllFranchisee: async function () {
      try {
        const { data } = await http.get(`${constants.API_URL}/api/franchisee`)
        this.allFranchisees = data.rows
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    async getCenterLogDetails () {
      this.isLoading = true
      try {
        let result = await http.get(
          `${constants.API_URL}/api/centerdetailsPreschool/preschoollog`
        )
        this.preschoollist = result.data
        this.total = this.preschoollist.length
      } catch (e) {
        this.preschoollist = []
      } finally {
        this.isLoading = false
      }
    },
    savecenterdetails: async function () {
      this.isLoading = true
      try {
        if (this.formValidation()) {
          const formData = new FormData()
          const appendData = (key, value) => {
            if (value !== undefined && value !== null) {
              formData.append(key, value)
            }
          }
          const basicInfo = {
            preSchoolName: this.preschoolname,
            franchiseeID: this.preschoolname,
            district: this.district,
            block: this.block,
            village: this.village,
            nearestPrimarySchool: this.nearestPrimarySchool,
            cluster: this.cluster,
            preSchoolNumber: this.preschoolnumber,
            addressLandmark: this.address,
            management: this.management,
            medium: this.medium,
            category: this.category,
            preSchoolEmail: this.preschoolEmail,
            preSchoolContactNo: this.preschoolContactNo,
            academicYearStarted: this.preschoolacademicYear,
            preSchoolWebsite: this.preschoolwebsite,
            lowestClass: this.lowestClass,
            highestClass: this.highestClass
          }
          Object.entries(basicInfo).forEach(([key, value]) => appendData(key, value))
          const managementDetails = {
            representativeName: this.managementreptname,
            representativeEmail: this.managementreptemail,
            representativeMobile: this.managementreptmobile,
            representativeDesignation: this.managementreptdesignation,
            schoolRegistrationNumber: this.schoolregistrationnumber,
            principalName: this.principalname,
            principalEmail: this.principalemail,
            principalMobile: this.principalmobile,
            principalHighestQualification: this.principalhighqualification,
            principalProfessionalQualification: this.principalprofqualification
          }
          Object.entries(managementDetails).forEach(([key, value]) => appendData(key, value))
          // appendData('principalCertificate', JSON.stringify(this.principalCertificate))
          if (this.principalCertificate) {
            formData.append('principalCertificate', this.principalCertificate)
          }
          // Nursery
          const nurseryBoys = Number(this.classDetails['nursery']?.boys || 0)
          const nurseryGirls = Number(this.classDetails['nursery']?.girls || 0)
          const nurseryClassrooms = Number(this.classDetails['nursery']?.classrooms || 0)
          const totalnursery = nurseryBoys + nurseryGirls
          appendData('totalnurseryboys', nurseryBoys)
          appendData('totalnurserygirls', nurseryGirls)
          appendData('totalnursery', totalnursery)
          appendData('nurserytotalClassrooms', nurseryClassrooms)
          // PP II (optional)
          const pp2Boys = Number(this.classDetails['pp II']?.boys || 0)
          const pp2Girls = Number(this.classDetails['pp II']?.girls || 0)
          const pp2Classrooms = Number(this.classDetails['pp II']?.classrooms || 0)
          const totalpp2 = pp2Boys + pp2Girls
          appendData('totalpp2boys', pp2Boys)
          appendData('totalpp2girls', pp2Girls)
          appendData('totalpp2', totalpp2)
          appendData('pp2totalClassrooms', pp2Classrooms)
          // Append Infrastructure Details
          const infraDetails = {
            buildingType: this.infra.buildingType,
            healthHygieneMaintained: this.infra.healthHygiene === 'yes',
            sanitationMaintained: this.infra.sanitation === 'yes',
            cleanlinessMaintained: this.infra.cleanliness === 'yes',
            facility: this.infra.facility && this.infra.facility.length ? JSON.stringify(this.infra.facility) : '',
            totalWashrooms: this.infra.washrooms,
            areapreSchoolsqft: this.infra.area,
            waterStorageCapacityLiters: this.infra.waterStorage,
            attendantsAvailable: this.infra.attendants === 'yes',
            attendantsMale: this.infra.attendantMale || 0,
            attendantsFemale: this.infra.attendantFemale || 0,
            childrenSpecialneeds: this.infra.specialNeeds === 'yes'
          }
          Object.entries(infraDetails).forEach(([key, value]) => appendData(key, value))
          // appendData('buildingCompletionCertificate', JSON.stringify(this.infra.buildingCert))
          if (this.infra.buildingCert) {
            formData.append('buildingCompletionCertificate', this.infra.buildingCert)
          }
          // appendData('cleanlinessMaintenanceCertificate', this.infra.cleanlinessCert)
          if (this.infra.cleanlinessCert) {
            formData.append('cleanlinessMaintenanceCertificate', this.infra.cleanlinessCert)
          }
          if (this.infra.specialNeeds === 'yes') {
            // Nursery
            appendData('specialneedsNurseryBoys', Number(this.specialNeedsInput.nursery.boys || 0))
            appendData('specialneedsNurseryGirls', Number(this.specialNeedsInput.nursery.girls || 0))
            appendData('specialneedsNurseryTotal', Number(this.specialNeedsInput.nursery.boys || 0) + Number(this.specialNeedsInput.nursery.girls || 0))
            // PP II
            appendData('specialneedsPP2Boys', Number(this.specialNeedsInput['pp II'].boys || 0))
            appendData('specialneedsPP2Girls', Number(this.specialNeedsInput['pp II'].girls || 0))
            appendData('specialneedsPP2Total', Number(this.specialNeedsInput['pp II'].boys || 0) + Number(this.specialNeedsInput['pp II'].girls || 0))
          }
          if (this.staffList.length > 0) {
            appendData('staffName', this.staffList.map(s => s.name || '').join(','))
            appendData('staffType', this.staffList.map(s => s.type || '').join(','))
            appendData('staffHighestedu', this.staffList.map(s => s.highestEdu || '').join(','))
            appendData('staffProfessionalQualification', this.staffList.map(s => s.profQualification || '').join(','))
            appendData('staffDateOfBirth', this.staffList.map(s => s.dob || '').join(','))
            appendData('staffDateOfJoin', this.staffList.map(s => s.doj || '').join(','))
            appendData('staffGender', this.staffList.map(s => s.gender || '').join(','))
            appendData('staffCertifications', this.staffList.map(s => {
              let arr = Array.isArray(s.certifications) ? s.certifications : typeof s.certifications === 'string' ? [s.certifications] : []
              return arr.join('|')
            }).join(','))
          }
          const response = await http.post(
            `${constants.API_URL}/api/centerdetailsPreschool/preschool`,
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          )
          if (response.data) {
            this.$dialog.info({
              title: 'Success',
              text: 'Pre-school center saved successfully!'
            })
          }
          setTimeout(() => {
            this.getCenterLogDetails()
          }, 500)
        }
      } catch (e) {
        const errorMessage = (e?.response?.data?.message) || e.message
        console.error('Error While Saving Data:', errorMessage)
        this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },

    formValidation () {
      if (!this.validateStaffList()) {
        return false
      }
      if (this.preschoolname === '') {
        this.errMsg('PreschoolName cannot be empty!')
      } else if (!this.district || this.district.trim() === '') {
        this.errMsg('District cannot be empty!')
      } else if (!this.block || this.block.trim() === '') {
        this.errMsg('Block cannot be empty!')
      } else if (!this.village || this.village.trim() === '') {
        this.errMsg('Village cannot be empty!')
      } else if (!this.nearestPrimarySchool || this.nearestPrimarySchool.trim() === '') {
        this.errMsg('NearestPrimary School cannot be empty!')
      } else if (this.lowestClass === '') {
        this.errMsg('LowestClass cannot be empty!')
      } else if (this.highestClass === '') {
        this.errMsg('HighestClass cannot be empty!')
      } else if (!this.principalname || this.principalname.trim() === '') {
        this.errMsg('Principal/Headmaster/In-charge Name cannot be empty!')
      } else if (!this.principalmobile || this.principalmobile.trim() === '') {
        this.errMsg('Principal/Headmaster/In-charge Mobile cannot be empty!')
      } else {
        return true
      }
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    resetAll: async function () {
      this.selectzone = ''
      this.selectefranchisee = ''
      if (this.franchisee) {
        this.franchiseeID = this.franchisee.id
      } else {
        this.franchiseeID = ''
      }
      this.getCenterLogDetails()
      this.hasSearched = false
    },
    onCWSNBoysInput (classValue, val) {
      const totalBoys = Number(this.classDetails[classValue].boys || 0)
      if (val === '' || isNaN(val)) {
        this.specialNeedsInput[classValue].boys = ''
        this.specialNeeds[classValue].boys = ''
        return
      }
      const cwsnBoys = Number(val)
      if (cwsnBoys > totalBoys) {
        this.popupMsg = 'CWSN Boys count cannot be greater than total boys in the respective class.'
        this.popup = true
        // Revert field to previous valid value (or empty)
        this.$nextTick(() => {
          this.specialNeedsInput[classValue].boys = this.specialNeeds[classValue].boys || ''
        })
      } else {
        this.specialNeedsInput[classValue].boys = cwsnBoys
        this.specialNeeds[classValue].boys = cwsnBoys
      }
    },
    onCWSNGirlsInput (classValue, val) {
      const totalGirls = Number(this.classDetails[classValue].girls || 0)
      if (val === '' || isNaN(val)) {
        this.specialNeedsInput[classValue].girls = ''
        this.specialNeeds[classValue].girls = ''
        return
      }
      const cwsnGirls = Number(val)
      if (cwsnGirls > totalGirls) {
        this.popupMsg = 'CWSN Girls count cannot be greater than total girls in the respective class.'
        this.popup = true
        // Revert field to previous valid value (or empty)
        this.$nextTick(() => {
          this.specialNeedsInput[classValue].girls = this.specialNeeds[classValue].girls || ''
        })
      } else {
        this.specialNeedsInput[classValue].girls = cwsnGirls
        this.specialNeeds[classValue].girls = cwsnGirls
      }
    },
    showValidation (msg) {
      this.popupMsg = msg
      this.popup = true
    },
    async applyFilter () {
      this.isLoading = true
      try {
        const payload = {
          region: this.selectzone,
          franchiseeID: this.selectfranchisee
        }
        const resp = await http.post(
          `${constants.API_URL}/api/centerdetailsPreschool/filterPreschoolLogs`,
          payload
        )
        this.preschoollist = resp.data
        this.total = this.preschoollist.length
        this.hasSearched = true
        if (this.preschoollist.length > 0) {
          this.populateFormFromLog(this.preschoollist[0])
        }
      } catch (e) {
        this.preschoollist = []
        this.hasSearched = true
        const errorMessage = (e?.response?.data?.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    populateFormFromLog (log) {
      if (!log) return
      // Basic Information
      this.preschoolname = log.preSchoolName || ''
      this.district = log.district || ''
      this.block = log.block || ''
      this.village = log.village || ''
      this.nearestPrimarySchool = log.nearestPrimarySchool || ''
      this.cluster = log.cluster || ''
      this.preschoolnumber = log.preSchoolNumber || ''
      this.address = log.addressLandmark || ''
      this.management = log.management || ''
      this.medium = log.medium || ''
      this.category = log.category || ''
      this.preschoolEmail = log.preSchoolEmail || ''
      this.preschoolContactNo = log.preSchoolContactNo || ''
      this.preschoolacademicYear = log.academicYearStarted || ''
      this.preschoolwebsite = log.preSchoolWebsite || ''
      this.lowestClass = log.lowestClass || ''
      this.highestClass = log.highestClass || ''

      // Management Details
      this.managementreptname = log.representativeName || ''
      this.managementreptemail = log.representativeEmail || ''
      this.managementreptmobile = log.representativeMobile || ''
      this.managementreptdesignation = log.representativeDesignation || ''
      this.schoolregistrationnumber = log.schoolRegistrationNumber || ''
      this.principalname = log.principalName || ''
      this.principalemail = log.principalEmail || ''
      this.principalmobile = log.principalMobile || ''
      this.principalhighqualification = log.principalHighestQualification || ''
      this.principalprofqualification = log.principalProfessionalQualification || ''
      this.principalCertificate = null // or log.principalCertificate if you want to show it

      // Class/Student Details
      this.classDetails = this.classDetails || {
        nursery: { boys: '', girls: '', classrooms: '' },
        'pp II': { boys: '', girls: '', classrooms: '' }
      }
      this.classDetails.nursery.boys = log.totalnurseryboys || ''
      this.classDetails.nursery.girls = log.totalnurserygirls || ''
      this.classDetails.nursery.classrooms = log.nurserytotalClassrooms || ''
      this.classDetails['pp II'].boys = log.totalpp2boys || ''
      this.classDetails['pp II'].girls = log.totalpp2girls || ''
      this.classDetails['pp II'].classrooms = log.pp2totalClassrooms || ''

      // Infrastructure Details
      this.infra = this.infra || {
        buildingType: '',
        buildingCert: null,
        healthHygiene: '',
        sanitation: '',
        cleanliness: '',
        cleanlinessCert: null,
        facility: [],
        washrooms: '',
        area: '',
        waterStorage: '',
        attendants: '',
        specialNeeds: '',
        attendantMale: 0,
        attendantFemale: 0
      }
      this.infra.buildingType = log.buildingType || ''
      this.infra.buildingCert = null
      this.infra.healthHygiene = log.healthHygieneMaintained ? 'yes' : 'no'
      this.infra.sanitation = log.sanitationMaintained ? 'yes' : 'no'
      this.infra.cleanliness = log.cleanlinessMaintained ? 'yes' : 'no'
      this.infra.cleanlinessCert = null
      this.infra.facility = log.facility ? JSON.parse(log.facility) : ''
      this.infra.washrooms = log.totalWashrooms || ''
      this.infra.area = log.areapreSchoolsqft || ''
      this.infra.waterStorage = log.waterStorageCapacityLiters || ''
      this.infra.attendants = log.attendantsAvailable ? 'yes' : 'no'
      this.infra.attendantMale = log.attendantsMale || ''
      this.infra.attendantFemale = log.attendantsFemale || ''
      this.infra.specialNeeds = log.childrenSpecialneeds ? 'yes' : 'no'

      // Special Needs Details
      this.specialNeedsInput = this.specialNeedsInput || {
        nursery: { boys: '', girls: '' },
        'pp II': { boys: '', girls: '' }
      }
      this.specialNeedsInput.nursery.boys = log.specialneedsNurseryBoys || ''
      this.specialNeedsInput.nursery.girls = log.specialneedsNurseryGirls || ''
      this.specialNeedsInput['pp II'].boys = log.specialneedsPP2Boys || ''
      this.specialNeedsInput['pp II'].girls = log.specialneedsPP2Girls || ''
      // Staff Details (multiple staff support)
      if (log.staffName) {
        const names = (log.staffName || '').split(',').map(x => x.trim())
        const types = (log.staffType || '').split(',').map(x => x.trim())
        const highestEdus = (log.staffHighestedu || '').split(',').map(x => x.trim())
        const profQualifications = (log.staffProfessionalQualification || '').split(',').map(x => x.trim())
        const dobs = (log.staffDateOfBirth || '').split(',').map(x => x.trim())
        const dojs = (log.staffDateOfJoin || '').split(',').map(x => x.trim())
        const genders = (log.staffGender || '').split(',').map(x => x.trim())
        const certsRaw = (log.staffCertifications || '').split(',').map(x => x.trim())
        const certifications = certsRaw.map(c => c ? c.split('|').map(y => y.trim()) : [])
        this.staffList = names.map((name, i) => ({
          name: name || '',
          type: types[i] || '',
          highestEdu: highestEdus[i] || '',
          profQualification: profQualifications[i] || '',
          dob: dobs[i] || '',
          doj: dojs[i] || '',
          gender: genders[i] || '',
          certifications: certifications[i] || []
        }))
        if (!this.staffList.length) {
          this.staffList = [{
            name: '',
            type: '',
            highestEdu: '',
            profQualification: '',
            dob: '',
            doj: '',
            gender: '',
            certifications: []
          }]
        }
      } else {
        // fallback for no staff
        this.staffList = [{
          name: '',
          type: '',
          highestEdu: '',
          profQualification: '',
          dob: '',
          doj: '',
          gender: '',
          certifications: []
        }]
      }
    },
    fileRules (value) {
      if (!value) return true
      const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png']
      if (!allowedTypes.includes(value.type)) {
        return 'File must be a PDF, JPEG, JPG, or PNG'
      }
      if (value.size > 1024 * 1024) return 'File must be less than 1 MB'
      return true
    },
    downloadCSV () {
      if (!this.preschoollist.length) {
        alert('No data available to download.')
        return
      }
      const booleanFields = [
        'healthHygieneMaintained',
        'sanitationMaintained',
        'cleanlinessMaintained',
        'attendantsAvailable',
        'childrenSpecialneeds'
      ]
      const franchiseeMap = this.allFranchisees.reduce((acc, f) => {
        acc[String(f.id)] = f.companyName
        return acc
      }, {})
      const csvData = this.preschoollist.map(item => {
        const row = { ...item }
        delete row.deletedAt
        delete row.id
        delete row.franchiseeID
        delete row.zoneId
        delete row.franchisee
        booleanFields.forEach(key => {
          if (row.hasOwnProperty(key)) {
            row[key] = row[key] === true || row[key] === 'true' ? 'Yes' : 'No'
          }
        })
        if (Array.isArray(row.facility)) {
          row.facility = row.facility.length ? row.facility.join(', ') : ''
        } else if (typeof row.facility === 'string') {
          try {
            const arr = JSON.parse(row.facility)
            row.facility = Array.isArray(arr) && arr.length ? arr.join(', ') : ''
          } catch {
          }
        }
        if (row.preSchoolName && franchiseeMap[String(row.preSchoolName)]) {
          row.preSchoolName = franchiseeMap[String(row.preSchoolName)]
        }
        return row
      })
      function escapeCSVField (value) {
        if (value === null || value === undefined) return ''
        if (Array.isArray(value) || typeof value === 'object') value = JSON.stringify(value)
        value = value.toString()
        // Escape quotes by doubling them
        if (/[",\n]/.test(value)) {
          value = '"' + value.replace(/"/g, '""') + '"'
        }
        return value
      }
      const headers = Object.keys(csvData[0])
      const headerRow = headers.join(',')
      const rows = csvData.map(item =>
        headers.map(key => escapeCSVField(item[key])).join(',')
      )
      const csvContent = [headerRow, ...rows].join('\n')
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      const url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute('download', 'preschoollist.csv')
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    downloadFormPDF () {
      if (this.preschoollist.length > 0) {
        this.populateFormFromLog(this.preschoollist[0])
      }
      this.printMode = true
      this.$nextTick(() => {
        this.printForm('printableSummary')
        setTimeout(() => {
          this.printMode = false
        }, 1000)
      })
    },
    printForm (contentId) {
      const el = document.getElementById(contentId)
      if (!el) {
        this.errMsg(`Element with id "${contentId}" not found!`)
        return
      }
      const htmlContent = el.innerHTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML
      }
      const printWindow = window.open('', '', 'left=0,top=0,width=850,height=1200,toolbar=0,scrollbars=1,status=0')
      printWindow.document.write(`<!DOCTYPE html>
    <html>
    <head>
      <title>Pre-school Details PDF</title>
      ${stylesHtml}
    </head>
    <body>
      ${htmlContent}
    </body>
    <style>
      body, p { font-size: 10pt; font-family: Arial, Helvetica, sans-serif; }
      body { margin: 2em; }
    </style>
    </html>
  `)
      printWindow.document.close()
      printWindow.focus()
      setTimeout(function () {
        printWindow.print()
      }, 500)
    },
    getUserRolesFromIndexDB: function () {
      this.isZonalManager = false
      this.isSuperAdmin = false
      this.isCH_LEVEL1 = false
      this.isAcademicManager = false
      if (stores.user.me && stores.user.me.superAdmin === true) {
        this.isSuperAdmin = true
      }
      if (stores.user.roles) {
        stores.user.roles.forEach(item => {
          if (item.role === constants.BUSINESS_DEVELOPER) {
            this.isZonalManager = true
          }
          if (item.role === constants.CH_LEVEL1) {
            this.isCH_LEVEL1 = true
          }
          if (item.role === constants.ACADEMIC_MANAGER) {
            this.isAcademicManager = true
          }
        })
      }
    },
    onFileChange (file, type) {
      if (file) {
        const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png']
        if (!allowedTypes.includes(file.type)) {
          this.showValidation('File must be a PDF, JPEG, JPG, or PNG')
          if (type === 'principal') this.principalCertificate = null
          if (type === 'building') this.infra.buildingCert = null
          if (type === 'cleanliness') this.infra.cleanlinessCert = null
          return
        }
        if (file.size > 1024 * 1024) {
          this.showValidation('File must be less than 1 MB')
          if (type === 'principal') this.principalCertificate = null
          if (type === 'building') this.infra.buildingCert = null
          if (type === 'cleanliness') this.infra.cleanlinessCert = null
          return
        }
        if (type === 'principal') this.principalCertificate = file
        if (type === 'building') this.infra.buildingCert = file
        if (type === 'cleanliness') this.infra.cleanlinessCert = file
      }
    },
    validateStaffList () {
      for (let i = 0; i < this.staffList.length; i++) {
        const staff = this.staffList[i]
        const entryNo = i + 1

        if (!staff.name || staff.name.trim() === '') {
          this.errMsg(`Staff Name cannot be empty! (Row ${entryNo})`)
          return false
        }
        if (!staff.type || staff.type.trim() === '') {
          this.errMsg(`Staff Teaching Type cannot be empty! (Row ${entryNo})`)
          return false
        }
        if (!staff.highestEdu || staff.highestEdu.trim() === '') {
          this.errMsg(`Staff Highest Educational Qualification cannot be empty! (Row ${entryNo})`)
          return false
        }
        if (!staff.profQualification || staff.profQualification.trim() === '') {
          this.errMsg(`Staff Professional Qualification cannot be empty! (Row ${entryNo})`)
          return false
        }
        if (!staff.dob || staff.dob.trim() === '') {
          this.errMsg(`Staff Date of Birth cannot be empty! (Row ${entryNo})`)
          return false
        }
        if (!staff.doj || staff.doj.trim() === '') {
          this.errMsg(`Staff Date of Joining cannot be empty! (Row ${entryNo})`)
          return false
        }
        if (!staff.gender || staff.gender.trim() === '') {
          this.errMsg(`Staff Gender cannot be empty! (Row ${entryNo})`)
          return false
        }
        if (!Array.isArray(staff.certifications) || staff.certifications.length === 0) {
          this.errMsg(`Staff Professional Qualification Certifications cannot be empty! (Row ${entryNo})`)
          return false
        }
      }
      return true
    }
  }
}
</script>

<style scoped>
.main-section-title {
  text-align: center;
  font-size: 2rem;
  font-weight: bold;
  color: #0284df;
  margin-top: 18px;
  margin-bottom: 18px;
  letter-spacing: 0.5px;
}
.section-wrapper {
  background: #eaf6ff;
  border-radius: 12px;
  padding: 24px 12px 12px 12px;
  margin-bottom: 32px;
  position: relative;
  border: 2px solid #0a0a0a;
}
.basic-info-card {
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(2,132,223,0.04);
  background: #fff;
  margin-top: 18px;
}
.tab-label {
  position: absolute;
  top: -18px;
  left: 18px;
  background: #0284df;
  color: #fff;
  border-radius: 8px 8px 0 0;
  padding: 4px 28px;
  font-weight: 700;
  font-size: 18px;
  box-shadow: 0 2px 4px rgba(2,132,223,0.14);
  z-index: 2;
}
.scroll-wrapper {
  overflow-x: auto;
  width: 100%;
}
.form-grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.form-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.form-field {
  flex: 1 1 22%;
  min-width: 180px;
}
.form-label {
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 3px;
}
.form-box {
  background: #fff;
  border: 1px solid #bbb;
  border-radius: 7px;
  min-height: 28px;
  padding: 5px 10px;
  font-size: 13px;
}
.section-wrapper {
  background: #eaf6ff;
  border-radius: 12px;
  padding: 18px 12px 12px 12px;
  margin-bottom: 32px;
  border: 2px solid #0a0a0a;
}
.tab-label {
  background: #0284df;
  color: #fff;
  border-radius: 8px 8px 0 0;
  padding: 4px 28px;
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 8px;
}
.main-section-title {
  text-align: center;
  font-size: 2rem;
  font-weight: bold;
  color: #0284df;
  margin-top: 18px;
  margin-bottom: 18px;
  letter-spacing: 0.5px;
}
.staff-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 8px;
}
.staff-table th,
.staff-table td {
  border: 1px solid #bbb;
  padding: 6px 8px;
  text-align: left;
}
.radio {
  margin-right: 12px;
  font-weight: bold;
}
</style>
